import type {
  ClaimGetAllParams,
  ClaimGetAllResponse,
  ClaimGetResponse,
  ClaimUpdateRequest,
  ClaimUpdateResponse,
  SubmitClaimResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ClaimApi {
  public async getAll(
    params: ClaimGetAllParams = {},
  ): Promise<ClaimGetAllResponse> {
    return await trpcClient.claim.getAll.query({ ...params });
  }

  public async getOne(id: string): Promise<ClaimGetResponse> {
    return await trpcClient.claim.getById.query({ id });
  }

  public async update(body: ClaimUpdateRequest): Promise<ClaimUpdateResponse> {
    return await trpcClient.claim.update.mutate({
      ...body,
    });
  }

  public async submit(id: string): Promise<SubmitClaimResponse> {
    return await trpcClient.claim.submit.mutate({
      id,
    });
  }
}
